import {useEffect, useRef} from 'react'
import {createPortal} from 'react-dom'

const getOrCreateContainer = (containerId) => {
    let container = document.getElementById(containerId)
    if (!container) {
        container = document.createElement('div')
        container.id = containerId
        document.body.appendChild(container)
    }
    return container
}

const Portal = ({children, containerId = 'portal-root'}) => {
    const containerRef = useRef(null)

    if (!containerRef.current) {
        containerRef.current = getOrCreateContainer(containerId)
    }

    useEffect(() => {
        return () => {
            const container = containerRef.current
            if (container && container.childNodes.length === 0) {
                document.body.removeChild(container)
                containerRef.current = null
            }
        }
    }, [])

    return createPortal(children, containerRef.current)
}

export default Portal
